import { HStack, Text } from '@ayble-health/dashboard-components';
import { Box, Separator } from '@chakra-ui/react';
import { HOUR_PX, lEFT_OFFSET } from 'components/ProviderHome/constants';

export const HourSlots = () => {
  const hourSlots = Array.from({ length: 24 }, (_, i) => {
    // Format the hour as a numeric string (e.g., "9:00", "14:00")

    const today = new Date();
    today.setHours(i, 0, 0, 0);

    return today.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  });

  return (
    <>
      {hourSlots.map((hour) => {
        return (
          <HStack h={`${HOUR_PX}px`} flexShrink={0} alignItems={'center'}>
            <Box w={`${lEFT_OFFSET}px`} flexShrink={0} position="relative">
              <Text fontSize={'2xs'}>{hour}</Text>
            </Box>
            <Separator w={'100%'} />
          </HStack>
        );
      })}
    </>
  );
};
